import { memo } from 'react';
import { useTranslation } from '@betty/i18n';
import { formatAmount } from '@betty/toolkit/utils';
import { PaymentStatusApprovedProps } from './PaymentStatusApproved.types';
import PaymentStatusBase from '../PaymentStatusBase/PaymentStatusBase';

function PaymentStatusApproved({
  amount,
  transactionType,
}: PaymentStatusApprovedProps) {
  const { t } = useTranslation('wallet');
  const context = { context: transactionType.toLowerCase() };

  return (
    <PaymentStatusBase
      image="common.success"
      title={t('paymentStatusApprovedTitle', {
        amount: formatAmount(amount),
        ...context,
      })}
      description={t('paymentStatusApprovedDescription', context)}
    />
  );
}

export default memo(PaymentStatusApproved);
